<template>
  <PopUp
    :show="show"
    :hideCloseIcon="true"
    @cancel="$emit('toggleAlreadyScheduledReportPopUp')"
    @complete="$emit('accept')">
    <template v-slot:header>
      <ScheduleIcon class="schedule-icon"></ScheduleIcon>
      <p class="title-text">This report is already scheduled</p>
    </template>
    <template v-slot:content>
      <div>
        <p>This report is already scheduled to send</p>
        <p class="scheduled-time">Weekly, Mondays at 10:30 AM EST</p>
        <p>and ends on</p>
        <p class="scheduled-time">December 30th, 2021 at 6 PM EST</p>
      </div>
    </template>
    <template v-slot:cancel>Edit Existing Schedule</template>
    <template v-slot:complete>Create New Schedule</template>
  </PopUp>
</template>

<script>
import {
  PopUp,
  ScheduleIcon,
} from '@mikmak/components';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    PopUp,
    ScheduleIcon,
  },
};
</script>

<style scoped lang="scss">
.pop-up::v-deep {
  .actions-wrapper {
    background-color: white;
  }

  h4.title {
    padding-bottom: 0;
  }

  .modal {
    max-width: 600px;
    padding-left: 0;
    padding-right: 0;
  }
}

.schedule-icon {
  width: 40px !important;
  height: 40px !important;
}

.scheduled-time {
  font-weight: 700;
}

.title-text {
  font-weight: 700;
  line-height: 33.6px;
  margin: 16px 0 0 0;
}
</style>
